import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface DailyQuote {
  id: string;
  quote_text: string;
  author: string | null;
  category: string;
  day_of_year: number;
}

export function useDailyQuote() {
  const [quote, setQuote] = useState<DailyQuote | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 0);
    const diff = now.getTime() - start.getTime();
    const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));

    async function fetch() {
      // Try exact day, fallback to modulo
      let { data } = await supabase
        .from("daily_quotes")
        .select("*")
        .eq("day_of_year", dayOfYear)
        .maybeSingle();

      if (!data) {
        // Fallback: get any quote using modulo
        const { data: allQuotes } = await supabase
          .from("daily_quotes")
          .select("*")
          .order("day_of_year");
        if (allQuotes && allQuotes.length > 0) {
          data = allQuotes[dayOfYear % allQuotes.length];
        }
      }

      setQuote(data as DailyQuote | null);
      setLoading(false);
    }
    fetch();
  }, []);

  return { quote, loading };
}
